import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  input() {
    this.element.value = this.element.value.toUpperCase()
  }

  paste(event) {
    event.preventDefault()

    const pastedText = event.clipboardData.getData("text")
    this.element.value = pastedText.replace(/\s+/g, "").toUpperCase()
    this.element.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
